<ng-container *ngIf="!!forensicCard">
  <div class="card" [ngClass]="[disabled ? 'disabled-card' : '', selected ? 'selected-card' : '']">
    <!-- adding mat ripple to mat card has a bug, mat card resizes on click, workaround -->
    <h4>{{ forensicCard.cardName }}</h4>
    <div class="options">
      <button
        mat-flat-button
        class="option"
        [ngClass]="[!disabled && isSelected(choice) ? 'option-selected' : 'option-not-selected']"
        *ngFor="let choice of forensicCard.choices"
        (click)="choiceClick(choice)"
      >
        {{ choice }}
      </button>
    </div>
  </div>
</ng-container>
